import { authHttp } from '../http'
import * as routes from '../../routes/ciot.routes'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'

// Declaração recusada volta com a lista de erros e o CIOT atualizado, para o modal manter o que foi digitado
function erroCiot(error) {
  const data = error && error.response && error.response.data
  if (data && typeof data === 'object' && data.message) {
    const erro = new Error(data.message)
    erro.erros = data.erros || [data.message]
    erro.ciot = data.ciot || null
    return erro
  }
  return errorHandler(error)
}

const listaIds = ids => (ids && ids.length ? ids.join(',') : undefined)

export async function getCiots(tpId, pInicial, pFinal, { emissorId, status } = {}) {
  try {
    const params = {
      tp_id: tpId || undefined,
      pInicial: parseToMysqlFormat(pInicial),
      pFinal: parseToMysqlFormat(pFinal),
      emissor_id: emissorId || undefined,
      status: status || undefined,
    }
    const { data } = await authHttp().get(routes.urlCiots, { params })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function getCiot(id) {
  try {
    const { data } = await authHttp().get(routes.urlCiot(id))
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function getDadosDeclaracaoCiot({
  emissorId,
  ciotId,
  fleetId,
  ctesIds,
  deliveriesIds,
  vehicleId,
  tipoCarga,
}) {
  try {
    const params = {
      emissor_id: emissorId,
      ciot_id: ciotId || undefined,
      fleet_id: fleetId || undefined,
      ctes_ids: listaIds(ctesIds),
      deliveries_ids: listaIds(deliveriesIds),
      vehicle_id: vehicleId || undefined,
      tipo_carga: tipoCarga || undefined,
    }
    const { data } = await authHttp().get(routes.urlDadosDeclaracaoCiot, { params })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function getCiotsDisponiveis({ tpId, emissorId, fleetId, placa }) {
  try {
    const params = {
      tp_id: tpId || undefined,
      emissor_id: emissorId,
      fleet_id: fleetId || undefined,
      placa: placa || undefined,
    }
    const { data } = await authHttp().get(routes.urlCiotsDisponiveis, { params })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function getPisoMinimoCiot({
  tipoCarga,
  eixos,
  distanciaKm,
  composicaoVeicular,
  altoDesempenho,
  retornoVazio,
}) {
  try {
    const params = {
      tipo_carga: tipoCarga,
      eixos,
      distancia_km: distanciaKm,
      composicao_veicular: Boolean(composicaoVeicular),
      alto_desempenho: Boolean(altoDesempenho),
      retorno_vazio: Boolean(retornoVazio),
    }
    const { data } = await authHttp().get(routes.urlPisoMinimoCiot, { params })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function postGerarCiot({ tpId, emissorId, fleetId, placa }) {
  try {
    const { data } = await authHttp().post(
      routes.urlGerarCiot,
      { emissor_id: emissorId, fleet_id: fleetId || null, placa: placa || null },
      { params: { tp_id: tpId || undefined } },
    )
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function postDeclararCiot(id, dados) {
  try {
    const { data } = await authHttp().post(routes.urlAcaoCiot(id, 'declarar'), { dados })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function postConsultarCiot(id) {
  try {
    const { data } = await authHttp().post(routes.urlAcaoCiot(id, 'consultar'))
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function postEncerrarCiot(id, pesoCarga) {
  try {
    const { data } = await authHttp().post(routes.urlAcaoCiot(id, 'encerrar'), {
      peso_carga: pesoCarga || undefined,
    })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function postCancelarCiot(id, motivo) {
  try {
    const { data } = await authHttp().post(routes.urlAcaoCiot(id, 'cancelar'), { motivo })
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}

export async function postRetificarCiot(id, campos) {
  try {
    const { data } = await authHttp().post(routes.urlAcaoCiot(id, 'retificar'), campos)
    return data
  } catch (error) {
    throw erroCiot(error)
  }
}
